import moment from "moment";
import { VoiceChannelImportedBooking } from "../../Services/PhoneToCnpContracts";
import { PhoneToCnpBookingDetails } from "./PhoneToCnpEntities";

export function ConvertVoiceChannelImportedBookingToPhoneToCnpBookingDetails(booking: VoiceChannelImportedBooking): PhoneToCnpBookingDetails {

    return {
        BookingId: booking.BookingId,
        DispatchBookingId: booking.DispatchBookingId,
        DispatchSystemId: booking.DispatchSystemId,
        Timing: booking.Timing,
        PassengerName: booking.PassengerName,
        Fare: booking.Fare,
        Pickup: booking.Pickup,
        DropOff: booking.DropOff,
        Payment: booking.Payment,
        SavedCard: booking.SavedCard,
        CustomerPhone: booking.CustomerPhone,
        TrackingInfo: {
            BookingID: booking.BookingId,
            VehicleLocation: null,// these null values will be populated later during the booking tracking.
            CarNumber: booking.CarNumberPlate,
            DriverName: booking.DriverName,
            DriverImage: booking.DriverImageUrl,
            DriverID: null,
            BookingStatusID: booking.StatusId,
            DispatchStartTime: null,
            DropoffTime: booking.MeterOffTime ? moment(booking.MeterOffTime) : null,
            PickedupTime: booking.MeterOnTime ? moment(booking.MeterOnTime) : null,
            ProofOfDeliveryUrls: null,
            DriverPhotoExists: booking.DriverImageUrl !== null,
            WasJitPreauthFailure: false,
            JitPreauthFailureMessage: null,
            TaxiFleetName: booking.TaxiFleetName,
        },
        Eta: null, // this will be populated later when the booking is accepted by a driver and we have the vehicle location to calculate ETA.
        AccessCode: booking.AccessCode,
        DataOwnership: booking.DataOwnership,
        ReadAccessCode: booking.ReadAccessCode,
        BookingShareUrl: booking.BookingShareUrl,
        GoogleOdrdTripId: booking.GoogleOdrdTripId,
        LastUpdated: booking.LastUpdated,
    }
}
